import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Input, Grid, Button, Select, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {downloadFile} from '../../../../common/util/file';
import {partClassification} from '../../../../common/dictionaries/classification';
import {paths} from '../../../../common/dictionaries/urls';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {enterKeyCode} from '../../../../common/constants/keyCodes';
import {buildParameters} from '../../../../common/util/parametersUtils';
import CpdQueriesTable from './table';
import './cpdQueriesList.scss';

class CpdQueriesList extends Component {
  constructor(props) {
    super(props);
    this.onCleanFilters = this.onCleanFilters.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onDownloadList = this.onDownloadList.bind(this);
    this.onCodeFilterChange = this.onCodeFilterChange.bind(this);
    this.checkEnterSubmit = this.checkEnterSubmit.bind(this);
    this.onDescriptionFilterChange = this.onDescriptionFilterChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(this.props.permissions, resources.Queries, scopes.See)
    ) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.clearFilters();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataSheetUrl !== this.props.dataSheetUrl && this.props.dataSheetUrl) {
      downloadFile(this.props.dataSheetUrl);
      this.props.clearDataSheetUrl();
    }
  }

  checkEnterSubmit(event) {
    if (event.keyCode === enterKeyCode) {
      this.onSearch();
    }
  }

  onCodeFilterChange(event) {
    this.props.changeCodeTextFilter(event.target.value);
  }

  onDescriptionFilterChange(event) {
    this.props.changeDescriptionTextFilter(event.target.value);
  }

  onLocationFilterChange(event) {
    this.props.changeLocationTextFilter(event.target.value);
  }

  onClassificationFilterChange(event, data) {
    this.props.changeClassificationTextFilter(data.value);
  }

  getClassificationOptions() {
    return Object.keys(partClassification).map((element) => {
      return {'text': partClassification[element], 'value': element};
    });
  }

  onCleanFilters() {
    this.props.clearFilters();
  }

  onDownloadList() {
    const parameters = buildParameters(this.props);
    this.props.downloadPartsList(parameters);
  }

  onSearch() {
    const parameters = buildParameters(this.props);
    this.props.fetchPartsList(parameters);
  }

  render() {
    const {
      filterCodeText,
      filterDescriptionText,
      filterLocationText,
      filterClassificationText,
      loading,
      downloading,
    } = this.props;

    const isDisabled = loading || downloading;

    return (
      <div className='cpd-queries-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <h2 className='title-bar-text'>Consulta Repuestos</h2>
            <p className='title-bar-description'>
              Puede realizar la búsqueda ingresando uno o más de los siguientes
              parámetros:
            </p>
            <div className='title-bar-actions'>
              <Grid columns='equal'>
                <Grid.Row>
                  <Grid.Column>
                    <Input
                      placeholder='Por código'
                      disabled={isDisabled}
                      value={filterCodeText}
                      onChange={this.onCodeFilterChange}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por descripción'
                      disabled={isDisabled}
                      value={filterDescriptionText}
                      onChange={this.onDescriptionFilterChange.bind(this)}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Input
                      placeholder='Por ubicación'
                      disabled={isDisabled}
                      value={filterLocationText}
                      onChange={this.onLocationFilterChange.bind(this)}
                      onKeyUp={this.checkEnterSubmit}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Select
                      placeholder='Por clasificación'
                      options={this.getClassificationOptions()}
                      disabled={isDisabled}
                      value={filterClassificationText}
                      onChange={this.onClassificationFilterChange.bind(this)}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      type='button'
                      secondary
                      className='toyota-secondary'
                      disabled={isDisabled}
                      onClick={this.onCleanFilters}
                      size='medium'
                    >
                      Limpiar
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      primary
                      type='submit'
                      className='toyota-primary'
                      disabled={isDisabled}
                      loading={loading}
                      onClick={this.onSearch}
                      size='medium'
                    >
                      Buscar
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      primary
                      disabled={isDisabled}
                      loading={downloading}
                      onClick={this.onDownloadList}
                    >
                      <Icon name='download' size='large' />
                      Excel
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <CpdQueriesTable />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.parts.loading,
    'downloading': state.parts.downloading,
    'filterCodeText': state.parts.filterCodeText,
    'filterDescriptionText': state.parts.filterDescriptionText,
    'filterLocationText': state.parts.filterLocationText,
    'filterClassificationText': state.parts.filterClassificationText,
    'pageNumber': state.parts.pageNumber,
    'permissions': state.session.permissions,
    'dataSheetUrl': state.parts.dataSheetUrl,
  };
};

const {
  fetchPartsList,
  downloadPartsList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changeLocationTextFilter,
  changeClassificationTextFilter,
  generatePartDataSheet,
  clearDataSheetUrl,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartsList,
  downloadPartsList,
  clearFilters,
  changeCodeTextFilter,
  changeDescriptionTextFilter,
  changeLocationTextFilter,
  changeClassificationTextFilter,
  generatePartDataSheet,
  clearDataSheetUrl,
  navigateTo,
})(CpdQueriesList);
